<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="_id"
      :headers="headers"
      :items="datiRaw"
      :options.sync="options"
      :loading="loading"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      dense
    >
<!--     
        :server-items-length="totaleDati"
        :disable-pagination="true"
      :hide-default-footer="true" -->
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>
          Comparazione tra giacenza fisica e giacenza contabile per le letture e le categorie scelte
          <v-btn icon @click="getDataFromApi" :loading="loading" title="Aggiorna i dati"><v-icon>mdi-refresh</v-icon></v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
      <v-row dense>
        <v-col xl="3" md="4" sm="8">
          <v-menu
            v-model="menuStart"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            class="mt-3"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataFormatted"
                label="Data giacenza"
                prepend-inner-icon="mdi-calendar"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
                clearable
                @click:clear="dataGiacenza = null"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataGiacenza" no-title scrollable @input="menuStart = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col xl="4" md="8" sm="12">
          <v-btn @click="getDataFromApi" :loading="loading" :disabled="loading" title="Aggiorna i dati" color="blue-grey" class="white--text">
            Esegui comparazione
            <template v-slot:loader>
              <span>Calcolo in corso</span>
            </template>
          </v-btn>
          <v-btn v-if="totaleDati > 0" class="ml-5" color="success" @click.stop="onToggleSelezione">{{ selected.length === datiRaw.length ? 'Annulla selezione' : 'Seleziona tutti' }}</v-btn>
        </v-col>
        <v-col xl="5" md="8" sm="12">
          <v-card>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-radio-group v-model="tipoMovimento" dense :disabled="loading || selected.length === 0">
                    <v-radio label="Movimenti di rettifica (consigliato)" value="rettifica"></v-radio>
                    <v-radio label="Movimenti di inventario" value="inventario"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col class="d-flex align-center">
                  <v-btn @click="onCreazioneMovimenti" :loading="loading" :disabled="loading || selected.length === 0" title="Creazione movimenti" color="blue-grey" class="white--text">
                    Crea movimenti
                    <template v-slot:loader>
                      <span>Creazione in corso</span>
                    </template>
                  </v-btn>                  
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
<!--         <v-col xl="3" md="8" sm="12">
 
        </v-col> -->
        <v-col xl="5" md="12" sm="12">
          <v-banner v-model="messaggioWarning" sticky transition="slide-y-transition" color="red lighten-2" elevation="10" dark>
            Attenzione! Alcune letture non appartengono alle categorie selezionate e non saranno considerate !
            <template v-slot:actions="{ dismiss }">
              <v-btn color="info" @click="dismiss">OK</v-btn>
            </template>
          </v-banner>
        </v-col>
      </v-row>
      </v-container>
    </template>
    <template v-slot:[`item.acquisto`]="{ item }">
      {{ item.acquisto | euro }}
    </template>
    <template v-slot:[`item.vendita`]="{ item }">
      {{ item.vendita | euro }}
    </template>
    <template v-slot:[`item.valore`]="{ item }">
      {{ item.valore | euro }}
    </template>
    <template v-slot:[`item.file`]="">
    </template>
    <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
      <v-simple-checkbox
        :value="item.delta ? isSelected : false"
        :disabled="!item.delta"
        :ripple="false"
        @input="select($event)"
        :title="item.delta || item.delta === 0 ? '' : 'Il prodotto non appartiene alle categorie scelte'"
      >
      </v-simple-checkbox>
    </template>
<!--     <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="completaItem(item)" v-bind="attrs" v-on="on">mdi-wrench-outline</v-icon>
        </template>
        <span>Completa le informazioni dei prodotti</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="downloadItem(item)" v-bind="attrs" v-on="on">mdi-cloud-download-outline</v-icon>
        </template>
        <span>Download informazioni prodotti</span>
      </v-tooltip>
    </template> -->
    <template v-slot:no-data>
      Nessun dato selezionato
    </template>
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
    <dialog-conferma
      :show="dialogConferma"
      :title="titoloConferma"
      :message="messaggioConferma"
      @dialog-confirm="onConferma"
      @dialog-cancel="dialogConferma=false"
    />    
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import magazzino from '@/services/magazzinoService'
  import excelService from '@/services/excelService'
  import DialogConferma from '@/components/dialogConferma'  
  import SpeedDial from './speedDial.vue'

  export default {
    components: {
      DialogConferma,
      SpeedDial
    },
    props: {
      reload: Number,
      letture: Array,
      incluse: Object,
      escluse: Object
    },
    data (vm) {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,        
        selected: [],
        loading: false,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        datiRaw: [],
        totaleDati: 0,
        intestazioniRaw: [],
        menuStart: false,
        messaggioWarning: false,
        tipoMovimento: 'rettifica', 
        dataGiacenza: moment().utcOffset(0, true).format().substr(0, 10), //  (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dialogConferma: false,
        titoloConferma: '',
        messaggioConferma: '',
        onConferma: vm.onCreazioneMovimenti
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      async reload() {
        // await this.getDataFromApi()
      },
      selected(value) {
        this.$emit('selezione', this.selected)
      },
      trigger(value) {

      },
      dataGiacenza (val) {
        this.dataFormatted = this.formatDate(this.dataGiacenza)
      }      
    },
    computed: {
      headers() {
        return this.intestazioniColonneRaw(this.datiRaw)
      },
      computedDataFormatted () {
        return this.formatDate(this.dataGiacenza)
      }
    },
    methods: {
      async onCreazioneMovimenti() {
        this.titoloConferma = "Creazione movimenti"
        let msg = `Confermi creazione movimenti di ${this.tipoMovimento} ?`
        if (this.tipoMovimento === 'rettifica') {
          msg += `<br /><br />Verranno creati movimenti con causale 'Rettifica' e<br />quantità tale da portare la giacenza al valore dell'inventario<br /><br />(Es. giacenza = 5, Inventario = 3 --> Movimento = -2)` 
        } else {
          msg += `<br /><br />Verranno creati movimenti con causale 'Inventario' e<br />quantità uguale  al valore dell'inventario<br /><br />(Es. giacenza = 5, Inventario = 3 --> Movimento = 3)`
          msg += `<br /><br />Questa causale è utile per creare un punto fermo nella giacenza ed eliminare i movimenti precedenti`
        }
        this.messaggioConferma = msg
        this.dialogConferma = true
        this.onConferma = this.creazioneMovimenti
      },
      async creazioneMovimenti() {
        this.dialogConferma = false
        for (let s of this.selected) {
          if (!s.delta) {
            const index = this.selected.indexOf(s)
            this.selected.splice(index, 1)
          }
        }
        // Chiedere conferma + spiegazione tipomovimento
        const magazzinoMovimento = this.$store.getters['magazzini/codiceMagazzino']
        await magazzino.creaMovimentiInventario(this.selected, this.tipoMovimento, magazzinoMovimento, this.dataGiacenza) // comparazione, tipoMovimento, magazzino, dataMovimento
        await this.getDataFromApi(null, true)
      },
      onToggleSelezione() {
        if (this.selected.length === this.datiRaw.length) {
          this.annullaSelezione()
        } else {
          this.onAggiungiTutti()
        }
      },
      onAggiungiTutti() {
        this.selected = [...this.datiRaw]
      },      
      async getDataFromApi (ev, quiet) {
        try {
          if (this.letture.length === 0) return
          this.loading = true
          const data = await magazzino.comparaLetture(this.letture, this.incluse, this.escluse, this.dataGiacenza)
          this.datiRaw = data
          this.totaleDati = data.length
          
          this.messaggioWarning = (data.filter(x => x.prezzo || x.delta !== 0).length !== data.length) && !quiet
        } catch(err) {
          this.datiRaw = []
          this.totaleDati = 0
        } finally {
          this.loading = false
          this.annullaSelezione()
        }
      },
      intestazioniColonneRaw(dati) {
        if (!dati || dati.length === 0) {
          return []
        }
        const riga = dati[0]
        // const keys = Object.keys(riga).filter(x => x !== '_id' && x !== 'file')
        const keys = Object.keys(riga).filter(x => x !== 'file')
        const colonne = keys.map(x => {
          return { value: x, text: x.toUpperCase() }
        })
        colonne.push({ text: 'Actions', value: 'actions', sortable: false })
        // colonne.push({ text: '', value: 'data-table-expand' })
        return colonne
      },      
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },     
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'export-riepilogo':
            const compara = this.selected
            if (compara.length > 0) {
              const riepilogo = compara // .map(x => _.omit(x, ['_id', 'dati', 'datiRaw']))
              await excelService.creaExcelFromArray(riepilogo, 'ComparazioneInventarioGiacenza.xlsx')
            }
            break      
          default:
            break
        }
      }   
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
